import { render } from "./PondForm.vue?vue&type=template&id=d5cdef14&scoped=true&ts=true"
import script from "./PondForm.vue?vue&type=script&lang=ts"
export * from "./PondForm.vue?vue&type=script&lang=ts"

import "./PondForm.vue?vue&type=style&index=0&id=d5cdef14&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cdef14"]])

export default __exports__